export const INVENTORY_DOCK_PAGE_ID = "inventory-stock";
export const ORDERS_DOCK_PAGE_ID = "orders";
export const PRODUCTS_CATEGORIES_DOCK_PAGE_ID = "products-categories";
export const PRODUCTS_ITEMS_DOCK_PAGE_ID = "products-items";
export const NON_DOCK_PANEL_KEY = "";

export const coversActivePanelKey = (registeredKey: string, activePanelKey: string): boolean =>
	registeredKey === activePanelKey || activePanelKey.startsWith(`${registeredKey}:`);

export const resolveActivePanelContentKey = (registeredKeys: string[], activePanelKey: string): string | undefined => {
	const dockKey = registeredKeys.find((key) => key !== NON_DOCK_PANEL_KEY && coversActivePanelKey(key, activePanelKey));
	if (dockKey) {
		return dockKey;
	}
	return registeredKeys.includes(NON_DOCK_PANEL_KEY) ? NON_DOCK_PANEL_KEY : undefined;
};

const buildPanelKey = (dockPageId: string | undefined, inventorySubTab?: string): string => {
	if (!dockPageId) {
		return "";
	}
	if (dockPageId === INVENTORY_DOCK_PAGE_ID && inventorySubTab) {
		return `${dockPageId}:${inventorySubTab}`;
	}
	return dockPageId;
};

export default buildPanelKey;
